module.exports = __webpack_public_path__ + "static/media/xzc.5c43b6c5.svg";